import React from "react";
import { ClerkProvider } from "@clerk/clerk-react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SignedIn, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";
import SignupPage from "./components/SignUpPage";
import SignIn from "./components/SignIn";
import ForgotPassword from "./components/ForgotPassword";
import DashboardLayout from "./components/DashboardLayout";
import ServerDetails from "./components/ServerDetails";
import Account from "./components/Account";
import OAuthCallbackPage from "./components/Callback";
import HelpSupport from "./components/Support";
import UpgradeToPro from "./components/UpgradeToPro";
import AllApps from "./components/AllApps";

// Replace with your actual Clerk frontend API key
const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const App = () => {
  return (
    <ClerkProvider
      publishableKey={clerkPubKey}
      appearance={{
        variables: { colorPrimary: "#a3e635" }, // Matching the lime-400 color from our UI
      }}
      // Add appropriate redirect URLs
      redirectUrl={window.location.origin + "/sso-callback"}
      // After sign-in
      afterSignInUrl="/dashboard"
      // After sign-up
      afterSignUpUrl="/dashboard"
    >
      <BrowserRouter>
        <Routes>
          {/* Public Route */}
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="*" element={<SignIn />} />

          {/* Protected Route Example */}
          <Route
            path="/dashboard"
            element={
              <>
                <SignedIn>
                  <DashboardLayout />
                </SignedIn>
                <SignedOut>
                  <RedirectToSignIn />
                </SignedOut>
              </>
            }
          >
            {/* <Route index element={<NoMCPServers />} /> */}
            <Route path="server/:id" element={<ServerDetails />} />
            <Route path="oauth/callback" element={<OAuthCallbackPage />} />
            <Route path="account" element={<Account />} />
            <Route path="apps" element={<AllApps />} />
            <Route path="support" element={<HelpSupport />} />
            <Route path="upgrade" element={<UpgradeToPro />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ClerkProvider>
  );
};

export default App;
